// /api/Submittion/GetCountByFormId

import axios from 'axios';
import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import Loading from '../../../SharedComponents/Loading';

export default function CountByFormId(props) {
  const { formId, name, icon } = props;
  const initialQuery = {
    formId: formId,
    fromDate: DateTime.now().startOf('month').toISODate(),
    toDate: DateTime.now().endOf('month').toISODate(),
  };
  const fetchCountByFormId = async (e) => {
    const { data } = await axios.post('Submittion/GetCountByFormId', e.queryKey[1]);
    return data;
  };

  const { data, isLoading, isError } = useQuery([`CountByFormId-${formId}`, initialQuery], fetchCountByFormId);

  if (isLoading)
    return (
      <div className="bg-white h-32 text-center flex justify-center items-center relative rounded-md shadow border p-4">
        <svg
          className="animate-spin -ml-1 mr-3 h-5 w-5 text-green-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </div>
    );
  if (isError) return '';
  const info = data.data;
  return (
    <>
      <div className="bg-white rounded-md shadow border p-4">
        <div className="flex  items-center justify-between">
          <div className="flex space-x-2 items-center space-x-reverse">
            {icon}
            <span>{name}</span>
          </div>
          <div>
            <span>{info.totalCount}</span>
          </div>
        </div>
        <hr className="block my-4" />
        <div className="grid grid-cols-3 gap-2 divide-x divide-x-reverse">
          <div className="px-2">
            <div className="flex justify-between">
              <span>قيد المراجعة</span>
              <span>{info.statusPending}</span>
            </div>
            <div className="bg-gray-100 h-2 w-full mt-2 relative">
              <div
                className="absolute h-full bg-yellow-500"
                style={{ width: `${(info.statusPending * 100) / info.totalCount}%` }}
              ></div>
            </div>
          </div>
          <div className="px-2">
            <div className="flex justify-between">
              <span>مقبول</span>
              <span>{info.statusAccepted}</span>
            </div>
            <div className="bg-gray-100 h-2 w-full mt-2 relative">
              <div
                className="absolute h-full bg-green-500"
                style={{ width: `${(info.statusAccepted * 100) / info.totalCount}%` }}
              ></div>
            </div>
          </div>
          <div className="px-2">
            <div className="flex justify-between">
              <span>مرفوض</span>
              <span>{info.statusRejected}</span>
            </div>
            <div className="bg-gray-100 h-2 w-full mt-2 relative">
              <div
                className="absolute h-full bg-red-500"
                style={{ width: `${(info.statusRejected * 100) / info.totalCount}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
